import { useLocation, useNavigate } from 'react-router-dom'
import { Container, Box, Typography, Paper, Button, Alert } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

import { OtherAdvisorInvitesPrompt } from './other-advisor-invites-prompt'

export function ClaimFundSuccess() {
  const navigate = useNavigate()
  const location = useLocation()
  const otherPendingInvites = location.state?.otherPendingInvites
  const fundId = location.state?.fundId

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom>
            You&apos;re All Set!
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your Financial Advisor Has Been Approved.
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mb: 4 }}>
          Your financial advisor currently has limited access to your Giving Fund. You can modify their access from
          within your Giving Fund profile.
        </Alert>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          onClick={() => navigate(fundId ? `/funds/${fundId}` : '/funds')}
        >
          Go to My Giving Fund
        </Button>
      </Paper>

      <OtherAdvisorInvitesPrompt invites={otherPendingInvites} useDirectMutations={false} />
    </Container>
  )
}
